export default {"src":"/_next/static/media/cross-recommendation.11c5e3cc.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};